import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontIndustryModuleTypes from '@/store/modules/frontDesk/industry/interface';

const frontIndustryModule: Module<FrontIndustryModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
      pageActivityList(context, searchParams) {
          return new Promise((resolve, reject) => {
              tool.post("/frontend/activity/anon/pageActivityList", searchParams).then(data => {
                  if (data.status === 2000) {
                      resolve(data);
                  }
                  else {
                      reject(data);
                  }
              });
          });
      },
      listActivity(context, searchParams) {
          return new Promise((resolve, reject) => {
              tool.post("/frontend/index/anon/listActivity", searchParams).then(data => {
                  if (data.status === 2000) {
                      resolve(data);
                  }
                  else {
                      reject(data);
                  }
              });
          });
      },
      getActivity(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/anon/getActivity", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      listJoinCategory(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/anon/listJoinCategory", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      getActivityApply(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/getActivityApply", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      saveActivityApply(context, params) {
          return new Promise((resolve, reject) => {
              tool.post("/frontend/activity/saveActivityApply", params).then(data => {
                  if (data.status === 2000) {
                      resolve(data);
                  }
                  else {
                      reject(data);
                  }
              });
          });
      },
      unloginSaveActivityApply(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/anon/unloginSaveActivityApply", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      getLastActivityOfTagName(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/getLastActivityOfTagName", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
    },
    },
};

export default frontIndustryModule;